import DataLayerEnum from '../enumerators/data-layer.enum'

export default class DataLayerAction {
    constructor() {
        DataLayerAction.dataLayerBrochure()
    }

    static dataLayerBrochure() {
        $(DataLayerEnum.BROCHURE_CARD_LINK_TRIGGER).on('click', function () {
            dataLayer.push({
                event: 'brochure',
                action: $(this).attr(DataLayerEnum.BROCHURE_CARD_LINK_TYPE),
                brochure_name: $(this)
                    .parent()
                    .find(DataLayerEnum.BROCHURE_CARD_TITLE)
                    .text()
                    .trim(),
            })
        })
    }
}
